import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FreudButtonModule } from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';
import { CircularProgressModule } from 'app/shared/circular-progress/circular-progress.module';

import { JourneyBoardModule } from '../journey-board/journey-board.module';
import { JourneyOverviewComponent } from './jouney-overview.component';

@NgModule({
	declarations: [JourneyOverviewComponent],
	imports: [
		CommonModule,
		JourneyBoardModule,
		FreudButtonModule,
		CircularProgressModule,
		TranslateModule,
	],
	exports: [JourneyOverviewComponent],
})
export class JourneyOverviewModule {}
